/* 
 References:
 https://www.w3.org/TR/webrtc-stats/
 https://developer.mozilla.org/en-US/docs/Web/API/WebRTC_Statistics_API
 https://stackoverflow.com/questions/63152869/detect-if-mediastreamtrack-is-black-blank
https://github.com/muaz-khan/getStats/blob/master/getStats.js
*/
// import {GLOBAL} from './GLOBAL.js';

export default class RTPStatistics {

  constructor(RTCpeer, interval, callback){
    this._peer = RTCpeer;
    this._interval = interval;
    this._showStat = callback; // callback
//    this._records = records; // array of objects used when export

    this._intervalId = undefined;
    this._previousBytesSent = {}; 
    this._previousBytesRcvd = {};
    this._previousTimeStamp = {};
    this._startTimeStamp = Date.now();

    this._getStats = this._getStats.bind(this);

    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
    this.export = this.export.bind(this);
  }

  start() {
    if (!this._peer) { console.error ('no RTC Peer'); return false; }
    try {
      this._intervalId = setInterval(this._getStats, this._interval*1000);
    } catch(e) {console.error(e);}
  }

  stop() {
    try {
      clearInterval(this._intervalId);
  //    this.export();
    } catch(e) {console.error(e);}
  }

  export(records) {
    try {
      const blob = new Blob (
         [JSON.stringify(records,null,'\t')],
         {type: 'text/plain;charset=utf8'}
      );

      const name = 'RTPStat';
      const extension = 'json';
      const filename = `${Date.now()}_${name}.` + extension;
 
      const saveLink = document.createElement("a");
      saveLink.href = URL.createObjectURL(blob);
      saveLink.download = filename;
      document.body.appendChild(saveLink);
      saveLink.click();
      document.body.removeChild(saveLink);

    } catch(e) {console.error(e);}
  }

  async _getStats() {
 
    try {
      const stats = await this._peer.getStats(); 
//      console.log('getStats raw stats\n', stats);
      const newStats = []; 

      const transports = [];
      const candidatePairs = [];
      const localCandidates = [];
      const remoteCandidates = [];
      const rtpStats = [];

// Web browser dependent
      stats.forEach( report => {
        if (report.type === 'transport') transports.push(report);

        if (report.type === 'candidate-pair' && report.state === 'succeeded')
          candidatePairs.push(report);
        if (report.type === 'remote-candidate') 
          remoteCandidates.push(report);
        if (report.type === 'local-candidate') 
          localCandidates.push(report);
        if (report.type === 'outbound-rtp' || report.type === 'inbound-rtp') 
          rtpStats.push(report);
      });

      const pairs = [];
      candidatePairs.forEach( pair => {
        const remote = remoteCandidates.find( remote => 
           remote.id === pair.remoteCandidateId
        );
        const local = localCandidates.find( local => 
           local.id === pair.localCandidateId
        );

        if (remote && local) {
          pairs.push({
            pair: pair, 
            remote: remote, 
            local: local
          });
        }
      });

      // console.log(JSON.stringify(pairs,null,'\t'));

      pairs.forEach ( pair => {
        let selected = 'undefined';
        if (pair.pair.selected !== undefined) // Firefox only?
          selected = pair.pair.selected;

        const tmp = {
          type: 'candidate-combined',
          transportId: pair.pair.transportId,
          selected: selected,
          bytesSent: pair.pair.bytesSent,
          bytesReceived: pair.pair.bytesReceived, 
          src: pair.remote.address + ':' + pair.remote.port,
          dst: pair.local.address + ':' + pair.local.port
        };
        newStats.push(tmp);
      });

// RTP info
      
      rtpStats.forEach( rtp => {

        const id = rtp.id.toString();
        if (!this._previousBytesSent[id]) this._previousBytesSent[id] = 0;
        if (!this._previousBytesRcvd[id]) this._previousBytesRcvd[id] = 0;
        if (!this._previousTimeStamp[id])
          this._previousTimeStamp[id] = this._startTimeStamp; 

        let kbps = undefined;
        if (rtp.type === 'outbound-rtp'){
           kbps = (rtp.bytesSent - this._previousBytesSent[id])*8
               / (rtp.timestamp - this._previousTimeStamp[id]);
           this._previousBytesSent[id] = rtp.bytesSent;
        }
        if (rtp.type === 'inbound-rtp'){
           kbps = (rtp.bytesReceived - this._previousBytesRcvd[id])*8
               / (rtp.timestamp - this._previousTimeStamp[id]);
           this._previousBytesRcvd[id] = rtp.bytesReceived;
        }

        this._previousTimeStamp[id] = rtp.timestamp;

        const tmp = {
          type: rtp.type,
          timeStamp: rtp.timestamp,
          kind: rtp.kind,
          SSRC: rtp.ssrc.toString(16),
          kbps: kbps
        }; 
        newStats.push(tmp);
      }); // end rtpStats.forEach 

      // console.log(JSON.stringify(newStats,null,'\t'));
      this._showStat(newStats);

    } catch (e) {console.error(e);}

  } // end getStats()

};
